import React from 'react'
import {
  Form,
  Radio,
  Label,
  Image,
  Icon,
  Button,
  Accordion,
  Modal,
  Divider,
  List
} from 'semantic-ui-react'
import Camera from '../../../../components/Devices/Camera/components/Camera'
import ImageCamera from '../../../../assets/camera_placeholder.jpg'
import ImageUser from '../../../../assets/user_placeholder.png'
import InputMask from 'react-input-mask';

import {Formik} from 'formik';
import {createCustomerValidationSchema} from '../models/formValidation'

import _ from "lodash";
import moment from "moment/moment";
import {getLanguageScope, C, capitalize, DFS, buildMessage} from '../../../../helpers'

const _i18n = getLanguageScope('check_cashing');
const v_i18n = getLanguageScope('validation');

class CreateCustomer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
      cameraModal: false,
      activePhoto: ''
    };

    this.findAddress = _.debounce(props.findAddress, 333);

    this.customerForm = null;

    this.renderCustomerCreate = this.renderCustomerCreate.bind(this);
    this.renderCustomerSearch = this.renderCustomerSearch.bind(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    const {appSetObj} = this.props;
    const {activePhoto} = this.state;

    if (prevState.s_customer_cell_phone_error !== this.state.s_customer_cell_phone_error) {
      this.customerForm.setFieldError('s_customer_cell_phone', this.state.s_customer_cell_phone_error ? v_i18n('invalid_phone') : '')
    }

    if (prevState.s_customer_email_error !== this.state.s_customer_email_error) {
      this.customerForm.setFieldError('s_customer_email', this.state.s_customer_email_error ? v_i18n('invalid_email') : '')
    }

    if (prevState.s_customer_ssn_duplicated !== this.state.s_customer_ssn_duplicated) {
      this.customerForm.setFieldError('s_customer_ssn', this.state.s_customer_ssn_duplicated ? v_i18n('duplicated_ssn') : '')
    }

    if (prevState.s_customer_id_duplicated !== this.state.s_customer_id_duplicated) {
      this.customerForm.setFieldError('s_customer_id_number', this.state.s_customer_id_duplicated ? v_i18n('duplicated_id') : '')
    }

    if (prevState.image_file_path !== this.state.image_file_path) {
      if (activePhoto === 's_customer_photo') {
        await appSetObj({
          s_customer_photo_path: this.state.image_file_path,
          photo_uploading_in_progress: false
        });
      }

      if (activePhoto === 's_customer_photo_id_front') {
        await appSetObj({
          s_customer_id_path_front: this.state.image_file_path,
          photo_uploading_in_progress: false
        });
      }

      if (activePhoto === 's_customer_photo_id_back') {
        await appSetObj({
          s_customer_id_path_back: this.state.image_file_path,
          photo_uploading_in_progress: false
        });
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.s_customer_cell_phone_error !== prevState.s_customer_cell_phone_error) {
      return {s_customer_cell_phone_error: nextProps.s_customer_cell_phone_error};
    }

    if (nextProps.s_customer_email_error !== prevState.s_customer_email_error) {
      return {s_customer_email_error: nextProps.s_customer_email_error};
    }

    if (nextProps.s_customer_ssn_duplicated !== prevState.s_customer_ssn_duplicated) {
      return {s_customer_ssn_duplicated: nextProps.s_customer_ssn_duplicated};
    }

    if (nextProps.s_customer_id_duplicated !== prevState.s_customer_id_duplicated) {
      return {s_customer_id_duplicated: nextProps.s_customer_id_duplicated};
    }

    if (nextProps.image_file_path && nextProps.image_file_path !== prevState.image_file_path) {
      return {image_file_path: nextProps.image_file_path}
    }

    else return null;
  }

  switchCustomerMode = () => {
    const {appSetVal, create_new_customer_mode} = this.props;

    appSetVal('create_new_customer_mode', !create_new_customer_mode);
  };

  changeCustomerSearchTerm = (value = '') => {
    const {appSetVal} = this.props;

    appSetVal('customer_search_term', value);
  };

  setAddressFields = async (value, setFieldValue) => {
    const {customer_address_search_results, appSetVal} = this.props;

    await appSetVal('s_customer_address', value);

    const address = _.find(customer_address_search_results, (i) => i.value === value);
    if (!address) return {};

    setFieldValue('s_customer_address1', address.address || '');
    setFieldValue('s_customer_address2', address.number || '');
    setFieldValue('s_customer_address_city', address.city || '');
    setFieldValue('s_customer_address_state', address.state || '');
  };

  handleModal = (modalActive, activePhoto) => {
    this.setState(() => ({cameraModal: modalActive, activePhoto: activePhoto}));
  };

  onPhotoCapture = async (photo) => {
    const {appSetVal, uploadPhoto} = this.props;
    const {activePhoto} = this.state;

    if (!activePhoto) return;
    await appSetVal(activePhoto, photo);

    uploadPhoto(photo);

    this.handleModal(false, activePhoto);
  };

  handleAccordionClick = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndex} = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({activeIndex: newIndex})
  };

  handleCreateCustomerSubmit = (values) => {
    const {createServiceCustomer} = this.props;

    createServiceCustomer(values);
  };

  renderCustomerCreate() {
    const {
      s_customer_address, s_customer_photo, s_customer_photo_id_front, s_customer_photo_id_back,
      customer_address_search_results, s_customer_first_name, s_customer_middle_name, s_customer_last_name,
      s_customer_cell_phone, s_customer_home_phone, s_customer_address1, s_customer_address2, s_customer_address_city,
      s_customer_address_state, s_customer_address_zip, s_customer_gender, s_customer_dob, s_customer_email,
      s_customer_ssn, s_customer_id_type, s_customer_id_number, s_customer_id_issuer, s_customer_id_expiration_date,
      s_customer_cell_phone_error,
      create_customer_in_process, photo_uploading_in_progress
    } = this.props;

    const {cameraModal, activeIndex} = this.state;

    return (
      <React.Fragment>

        <Formik
          initialValues={{
            s_customer_first_name,
            s_customer_middle_name,
            s_customer_last_name,
            s_customer_cell_phone,
            s_customer_home_phone,
            s_customer_address1,
            s_customer_address2,
            s_customer_address_city,
            s_customer_address_state,
            s_customer_address_zip,
            s_customer_gender,
            s_customer_dob,
            s_customer_email,
            s_customer_ssn,
            s_customer_id_type,
            s_customer_id_number,
            s_customer_id_issuer,
            s_customer_id_expiration_date,
            s_customer_address,
            s_customer_cell_phone_error
          }}
          ref={(ref) => this.customerForm = ref}
          validationSchema={createCustomerValidationSchema()}
          onSubmit={(values) => this.handleCreateCustomerSubmit(values)}
          render={({values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting}) => (
            <Form style={{marginTop: 20}}>
              <Form.Group widths='equal'>
                <Form.Field>

                  <Form.Input
                    required
                    className={'form-field-pb5'}
                    value={values.s_customer_first_name}
                    label={_i18n('first_name')}
                    name={'s_customer_first_name'}
                    error={!!(errors.s_customer_first_name && touched.s_customer_first_name)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {errors.s_customer_first_name && touched.s_customer_first_name &&
                  <Label className={'label-custom'} basic color='red' pointing>{errors.s_customer_first_name}</Label>}

                  <Form.Input
                    className={'form-field-pb5'}
                    value={values.s_customer_middle_name}
                    label={_i18n('middle_name')}
                    name={'s_customer_middle_name'}
                    error={!!(errors.s_customer_middle_name && touched.s_customer_middle_name)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {errors.s_customer_middle_name && touched.s_customer_middle_name &&
                  <Label className={'label-custom'} basic color='red' pointing>{errors.s_customer_middle_name}</Label>}

                  <Form.Input
                    required
                    className={'form-field-pb5'}
                    value={values.s_customer_last_name}
                    label={_i18n('last_name')}
                    name={'s_customer_last_name'}
                    error={!!(errors.s_customer_last_name && touched.s_customer_last_name)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {errors.s_customer_last_name && touched.s_customer_last_name &&
                  <Label className={'label-custom'} basic color='red' pointing>{errors.s_customer_last_name}</Label>}

                </Form.Field>

                <Form.Field style={{textAlign: 'center'}}>
                  <Label pointing='below'>{_i18n('customer_photo')}</Label>
                  <Image disabled={photo_uploading_in_progress} centered size='small' style={{cursor: 'pointer'}}
                         onClick={() => this.handleModal(true, 's_customer_photo')}
                         src={s_customer_photo ? s_customer_photo : ImageUser}/>
                </Form.Field>

              </Form.Group>

              <Form.Group widths='equal'>

                <Form.Field>
                  <Form.Input error={!!(errors.s_customer_cell_phone && touched.s_customer_cell_phone)} required
                              label={_i18n('cell_phone')}>
                    <InputMask
                      name={'s_customer_cell_phone'}
                      value={values.s_customer_cell_phone}
                      onChange={(e) => setFieldValue('s_customer_cell_phone', DFS(e.currentTarget.value))}
                      onBlur={handleBlur}
                      error={!!(errors.s_customer_cell_phone && touched.s_customer_cell_phone)}
                      mask="+1\ (999) 999-9999" maskChar="_"/>
                  </Form.Input>
                  {errors.s_customer_cell_phone && touched.s_customer_cell_phone &&
                  <Label basic color='red' pointing>{errors.s_customer_cell_phone}</Label>}
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    value={values.s_customer_home_phone}
                    name={'s_customer_home_phone'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.s_customer_home_phone && touched.s_customer_home_phone)}
                    label={_i18n('home_phone')}
                  />

                  {errors.s_customer_home_phone && touched.s_customer_home_phone &&
                  <Label basic color='red' pointing>{errors.s_customer_home_phone}</Label>}
                </Form.Field>

              </Form.Group>

              <Divider hidden/>

              <Form.Group widths='equal'>
                <Form.Dropdown
                  search={(list) => list}
                  searchInput={{type: 'text', autoComplete: 'new-password'}}
                  selection
                  options={customer_address_search_results}
                  value={s_customer_address}
                  label={_i18n('address_search')}
                  onChange={(e, {name, value}) => this.setAddressFields(value, setFieldValue)}
                  onSearchChange={e => this.findAddress(e.target.value)}
                />
              </Form.Group>

              <Form.Group widths='equal'>

                <Form.Field>
                  <Form.Input
                    required
                    value={values.s_customer_address1}
                    name={'s_customer_address1'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.s_customer_address1 && touched.s_customer_address1)}
                    label={_i18n('address1')}
                  />

                  {errors.s_customer_address1 && touched.s_customer_address1 &&
                  <Label basic color='red' pointing>{errors.s_customer_address1}</Label>}
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    value={values.s_customer_address2}
                    name={'s_customer_address2'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.s_customer_address2 && touched.s_customer_address2)}
                    label={_i18n('address2')}
                  />

                  {errors.s_customer_address2 && touched.s_customer_address2 &&
                  <Label basic color='red' pointing>{errors.s_customer_address2}</Label>}
                </Form.Field>

              </Form.Group>

              <Form.Group>
                <Form.Field width={6}>
                  <Form.Input
                    required
                    label={_i18n('address_city')}
                    value={values.s_customer_address_city}
                    name={'s_customer_address_city'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.s_customer_address_city && touched.s_customer_address_city)}
                  />

                  {errors.s_customer_address_city && touched.s_customer_address_city &&
                  <Label basic color='red' pointing>{errors.s_customer_address_city}</Label>}
                </Form.Field>

                <Form.Field width={6}>
                  <Form.Input
                    required
                    label={_i18n('address_state')}
                    value={values.s_customer_address_state}
                    name={'s_customer_address_state'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.s_customer_address_state && touched.s_customer_address_state)}
                  />

                  {errors.s_customer_address_state && touched.s_customer_address_state &&
                  <Label basic color='red' pointing>{errors.s_customer_address_state}</Label>}
                </Form.Field>

                <Form.Field width={4}>
                  <Form.Input
                    required
                    label={_i18n('address_zip')}
                    value={values.s_customer_address_zip}
                    name={'s_customer_address_zip'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.s_customer_address_zip && touched.s_customer_address_zip)}
                  />

                  {errors.s_customer_address_zip && touched.s_customer_address_zip &&
                  <Label basic color='red' pointing>{errors.s_customer_address_zip}</Label>}
                </Form.Field>
              </Form.Group>

              <Divider hidden/>

              <Form.Group widths='equal'>
                <Form.Select
                  label={_i18n('gender')}
                  name={'c'}
                  value={values.s_customer_gender}
                  defaultValue={'unknown'}
                  options={[
                    {key: 'm', text: _i18n('male'), value: 'male'},
                    {key: 'f', text: _i18n('female'), value: 'female'},
                    {key: 'г', text: _i18n('unknown'), value: 'unknown'},
                  ]}
                  onChange={(e, {name, value}) => setFieldValue('s_customer_gender', value)}
                  onBlur={() => setFieldTouched('s_customer_gender')}
                />

                <Form.Field>
                  <Form.Input
                    value={values.s_customer_dob}
                    name={'s_customer_dob'}
                    type={'date'}
                    label={_i18n('date_of_birth')}
                    error={!!(errors.s_customer_dob && touched.s_customer_dob)}
                    onChange={(e, {name, value}) => setFieldValue('s_customer_dob', moment(value).format('YYYY-MM-DD'))}
                    onBlur={handleBlur}
                  />

                  {errors.s_customer_dob && touched.s_customer_dob &&
                  <Label basic color='red' pointing>{errors.s_customer_dob}</Label>}
                </Form.Field>
              </Form.Group>

              <Form.Group widths='equal'>
                <Form.Field>
                  <Form.Input
                    value={values.s_customer_email}
                    name={'s_customer_email'}
                    label={_i18n('email')}
                    type='email'
                    error={!!(errors.s_customer_email && touched.s_customer_email)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {errors.s_customer_email && touched.s_customer_email &&
                  <Label basic color='red' pointing>{errors.s_customer_email}</Label>}
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    required
                    value={values.s_customer_ssn}
                    name={'s_customer_ssn'}
                    label={_i18n('ssn')}
                    error={!!(errors.s_customer_ssn && touched.s_customer_ssn)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {errors.s_customer_ssn && touched.s_customer_ssn &&
                  <Label basic color='red' pointing>{errors.s_customer_ssn}</Label>}
                </Form.Field>
              </Form.Group>

              <Accordion>
                <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleAccordionClick}>
                  <Icon name='dropdown'/>
                  {_i18n('id_details')}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <Form.Select
                        label={_i18n('id_type')}
                        name={'s_customer_id_type'}
                        value={values.s_customer_id_type}
                        defaultValue={'Passport'}
                        options={[
                          {key: 'ps', text: _i18n('passport'), value: 'Passport'},
                          {key: 'id', text: _i18n('id_card'), value: 'ID Card'}
                        ]}
                        onChange={(e, {name, value}) => setFieldValue('s_customer_id_type', value)}
                        onBlur={() => setFieldTouched('s_customer_id_type')}
                      />
                      {errors.s_customer_id_type && touched.s_customer_id_type &&
                      <Label basic color='red' pointing>{errors.s_customer_id_type}</Label>}
                    </Form.Field>

                    <Form.Field>
                      <Form.Input
                        required
                        name={'s_customer_id_number'}
                        value={values.s_customer_id_number}
                        label={_i18n('id_number')}
                        error={!!(errors.s_customer_id_number && touched.s_customer_id_number)}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                      {errors.s_customer_id_number && touched.s_customer_id_number &&
                      <Label basic color='red' pointing>{errors.s_customer_id_number}</Label>}
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <Form.Input
                        required
                        name={'s_customer_id_issuer'}
                        value={values.s_customer_id_issuer}
                        label={_i18n('id_issuer')}
                        error={!!(errors.s_customer_id_issuer && touched.s_customer_id_issuer)}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                      {errors.s_customer_id_issuer && touched.s_customer_id_issuer &&
                      <Label basic color='red' pointing>{errors.s_customer_id_issuer}</Label>}
                    </Form.Field>

                    <Form.Field>
                      <Form.Input
                        required
                        name={'s_customer_id_expiration_date'}
                        type={'date'}
                        value={values.s_customer_id_expiration_date}
                        label={_i18n('id_expiration_date')}
                        error={!!(errors.s_customer_id_expiration_date && touched.s_customer_id_expiration_date)}
                        onChange={(e, {name, value}) => setFieldValue('s_customer_id_expiration_date', moment(value).format('YYYY-MM-DD'))}
                        onBlur={handleBlur}
                      />

                      {errors.s_customer_id_expiration_date && touched.s_customer_id_expiration_date &&
                      <Label basic color='red' pointing>{errors.s_customer_id_expiration_date}</Label>}
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label>{_i18n('id_front_image')}</label>
                      <Image centered size='big' disabled={photo_uploading_in_progress}
                             style={{cursor: 'pointer'}}
                             onClick={() => this.handleModal(true, 's_customer_photo_id_front')}
                             src={s_customer_photo_id_front ? s_customer_photo_id_front : ImageCamera}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{_i18n('id_back_image')}</label>
                      <Image centered size='big' disabled={photo_uploading_in_progress}
                             onClick={() => this.handleModal(true, 's_customer_photo_id_back')}
                             src={s_customer_photo_id_back ? s_customer_photo_id_back : ImageCamera}
                      />
                    </Form.Field>
                  </Form.Group>
                </Accordion.Content>
              </Accordion>

              <div>
                <Button disabled={create_customer_in_process} loading={create_customer_in_process}
                        icon labelPosition='right'
                        floated={'right'} type={'submit'} color={'violet'} onClick={handleSubmit}>
                  {_i18n('create_customer')}
                  <Icon name='user add'/>
                </Button>
              </div>

            </Form>
          )}
        />

        <Modal style={{height: 'auto', width: 'auto'}}
               basic
               closeOnDocumentClick={true}
               onClose={() => this.handleModal(false, '')}
               open={cameraModal}>
          <Camera onPhotoCapture={this.onPhotoCapture} onCloseCamera={() => this.handleModal(false, '')}/>
        </Modal>

      </React.Fragment>
    );
  }

  renderCustomersList() {
    const {s_customer_list} = this.props;

    if (!(s_customer_list && s_customer_list.length)) return null;

    return (
      <List divided verticalAlign='middle'>
        {_.map(s_customer_list || [], (c, key) => {
          return (
            <List.Item as='a' className={'list-item'} onClick={() => this.selectCustomer(c)} key={key}>
              <List.Content className={'list-item-text'} verticalAlign='middle'>
                <List.Header>
                  {buildMessage([c.first_name, c.last_name], ' ')}
                  <span className={'ssn-text'}>{` (SSN: ${c.ssn})`}</span>
                </List.Header>
                {buildMessage(c.address, ', ')}
              </List.Content>
            </List.Item>
          )
        })}
      </List>
    )
  }

  selectCustomer = async(customer) => {
    const { appSetObj } = this.props;

    const address = customer.address;
    const customerImage = customer.customer_image;

    const updateObj = {
      s_customer_id: customer.id,
      s_customer_first_name: customer.first_name,
      s_customer_middle_name: customer.middle_name ,
      s_customer_last_name: customer.last_name,
      s_customer_cell_phone: customer.cell_phone,
    };

    if(address){
      updateObj.s_customer_address1 = address.address1;
      updateObj.s_customer_address2 = address.address2;
      updateObj.s_customer_city = address.city;
      updateObj.s_customer_state = address.state;
      updateObj.s_customer_zip = address.zip;
    }

    if(customerImage){
      updateObj.s_customer_photo = `data:image/${customerImage.image_type};base64,${customerImage.image}`;
    }

    appSetObj(updateObj);
  };

  renderCustomerSearch() {
    const {customer_search_term, disable_do_search, do_search_in_progress, doCustomerSearch} = this.props;

    return (
      <Form>
        <Form.Field style={{marginTop: 20}}>
          <Form.Input
            fluid
            iconPosition='left'
            icon='search'
            color={'red'}
            label={_i18n('search_customer')}
            value={customer_search_term}
            onChange={(e, {name, value}) => this.changeCustomerSearchTerm(value)}
            placeholder={_i18n('search_placeholder')}
            action={{
              labelPosition: 'right',
              icon: 'search',
              loading: do_search_in_progress,
              content: _i18n('search'),
              disabled: disable_do_search,
              onClick: () => doCustomerSearch()
            }}/>
        </Form.Field>

        {this.renderCustomersList()}
      </Form>
    )
  }

  render() {
    const {create_new_customer_mode} = this.props;

    return (
      <React.Fragment>
        <Form>
          <Form.Field style={{marginTop: 20}}>
            <Radio
              toggle
              checked={create_new_customer_mode}
              onChange={this.switchCustomerMode}
              label={_i18n('create_new_customer')}/>
          </Form.Field>
        </Form>
        {create_new_customer_mode ? this.renderCustomerCreate() : this.renderCustomerSearch()}
      </React.Fragment>
    )
  }
}

export default CreateCustomer;




// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/components/CreateCustomer.js